import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAuthUser from "../../../hooks/useAuthUser.js";

const TabNavigation = () => {
  const { loggedInUser } = useAuthUser();
  const userRole = Number(loggedInUser?.role);

  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [];

  if ([1, 2].includes(userRole)) {
    tabs.push(
      {
        name: "Custom Field",
        path: "/setting/custom-field",
      },
      {
        name: "Mail Template",
        path: "/setting/mail-template",
      },
      {
        name: "Compliance Master",
        path: "/setting/compliance-master",
      },
      {
        name: "Grievance Setting",
        path: "/setting/grievance-setting",
      }
    );
  }

  useEffect(() => {
    const isValidPath = tabs.some(
      (tab) =>
        location.pathname === tab.path ||
        location.pathname.startsWith(`${tab.path}/`)
    );

    if (!isValidPath && tabs.length > 0) {
      navigate(tabs[0].path, { replace: true });
    }
  }, [location.pathname, navigate, tabs]);

  return (
    <>
      <ul className="nav nav-tabs" role="tablist">
        {tabs.map((tab) => {
          const isActive =
            location.pathname === tab.path ||
            location.pathname.startsWith(`${tab.path}/`);

          return (
            <li className="nav-item" key={tab.path}>
              <button
                className={`nav-link ${isActive ? "active" : ""}`}
                onClick={() => navigate(tab.path)}
                type="button"
              >
                {tab.name}
              </button>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default TabNavigation;